import axios from "axios";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
export const FETCH_SPAM_RANGE = "FETCH_SPAM_RANGE";
import { getAccessToken, getCompanyId } from "./utils";

export function onSpamRangeChange(params) {
    return function (dispatch) {
        axios
            .patch(getUrl("spamRange") + getCompanyId() + "?access-token=" + getAccessToken(), JSON.stringify(params), {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((resp) => {
                toast.success("Spam range updated successfully");
            })
            .catch((err) => {
                toast.error("Spam range update failed");
            });
    };
}

export function fetchSpamRange() {
    let resp = axios
        .get(getUrl("spamRange") + getCompanyId() + "?access-token=" + getAccessToken(), {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => response.data)
        .catch((err) => toast.error("SPAM Range Fetch failed"));
    return {
        type: FETCH_SPAM_RANGE,
        payload: resp,
    };
}
